import { usePathname } from 'expo-router';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { Platform } from 'react-native';

import {
    getStaticPublicExportPrefix,
    isLocalizedPublicPath,
    PUBLIC_WEB_CANONICAL_ORIGIN,
    stripStaticPublicExportPrefix,
} from '../lib/i18n/publicWeb';

/**
 * A non-default locale bundle may render only manifest-approved public paths.
 * Crossing into account/app/editorial routes performs a full navigation back
 * to the unprefixed application instead of inventing a localized alias.
 */
export default function PublicWebExportBoundary({ children }: { children: ReactNode }) {
    const pathname = usePathname();
    const publicPrefix = Platform.OS === 'web' ? getStaticPublicExportPrefix() : '';
    const logicalPathname = stripStaticPublicExportPrefix(pathname);
    const allowed = !publicPrefix || isLocalizedPublicPath(logicalPathname);

    useEffect(() => {
        if (
            Platform.OS !== 'web'
            || allowed
            || typeof window === 'undefined'
        ) {
            return;
        }
        window.location.replace(
            `${PUBLIC_WEB_CANONICAL_ORIGIN}${logicalPathname}${window.location.search}${window.location.hash}`
        );
    }, [allowed, logicalPathname]);

    if (!allowed) {
        return null;
    }
    return children;
}
